import { MmcDataSource } from '../index';
import { configs } from '../configs';
import { memoizeWithAllArgsHashed as memoize } from '../utils';
import { isLocal } from './mocks/mock-mmc-data-sources';
import { mockCampaignStoreQueries } from './mocks/mock-campaign-store-queries';

const entities = {
  getCampaignStoresEntity: memoize(storeId => new MmcDataSource({
    entityName: 'CampaignStores',
    routePrefix: configs.routes.oDataRoute,
    endpoint: configs.endpoints.campaignStores,
    idAttribute: storeId,
  })),
};

export const campaignStoreQueries = {
  getActiveCampaignStores(options) {
    const entity = entities.getCampaignStoresEntity();

    const params = {
      query: {
        $select: 'IsActive, IsGlobalStore, LinkedStoreId, NetworkTypes, RetailerStoreId, RetailerStoreName',
        $filter: '(IsActive eq true)',
        $top: 1000000,
      },
    };

    return entity.findAll(params, options);
  },
};

export const getCampaignStoreQueriesWithLocalMock = () => {
  if (isLocal()) {
    return mockCampaignStoreQueries;
  }

  return campaignStoreQueries;
};
